import * as THREE from 'three'
import Particles from './fieldScripts/class/Particles'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import gsap from 'gsap'
import Loader from '../utils/Loader.js'

export default class Home{
  constructor(){

    this.scene
    this.camera
    this.particles
    this.directionalLight
    this.runningAnim = null
    this.Loader = new Loader()

    // Deer
    this.deerGroup = new THREE.Group()

    // MouseAnim
    this.cameraNeedUpdate = false
    this.mouseEvent
    this.cameraAmplitude = 1

    this.setScene()
    this.setCamera()
    this.loadDeer()
    this.setFog()
  }

  setScene(){
    this.scene = new THREE.Scene()
  }

  setCamera(){
    this.camera = new THREE.PerspectiveCamera(75, 0, 0.1, 100)
    this.camera.position.z = 15
    this.camera.position.x = -3
  }
  
  loadDeer(){
    const loader = new GLTFLoader()
    const headMaterial = new THREE.MeshBasicMaterial({
      color: 0x111111,
      wireframe: true
    })    

    loader.load('./assets/models/deerhead.glb', gltf => {
      const deerHead = gltf.scene.children[0]
      const deerWoods = gltf.scene.children[1]

      deerHead.material = headMaterial      
      
      this.particles = new Particles(deerWoods, this.camera)
      
      this.deerGroup.add(deerHead)
      this.deerGroup.add(this.particles.points)
      this.deerGroup.add(this.particles.staticPoints)
      this.deerGroup.rotation.y = -Math.PI * 0.15

      this.scene.add(this.deerGroup)
      this.Loader.close()
    })
  }

  setFog(){
    const fog = new THREE.Fog(0xffffff, 12, 20)
    this.scene.fog = fog
  }

  setNavigation(canvas){
    canvas.addEventListener('mousemove', event => {
      this.mouseEvent = {
        x: event.clientX,
        y: event.clientY
      }
      this.cameraNeedUpdate = true
    })
    canvas.addEventListener('touchmove', event => {
      this.mouseEvent = {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
      }
      this.cameraNeedUpdate = true
    })
  }

  animCamera(){
    const posX = ((this.mouseEvent.x / window.innerWidth) - 0.5) * this.cameraAmplitude
    const posY = ((this.mouseEvent.y / window.innerHeight) - 0.5) * this.cameraAmplitude

    if(this.runningAnim){
      this.runningAnim.kill()
    }

    this.runningAnim = gsap.to(this.deerGroup.rotation, {
      "x": posY,
      "y": posX - (Math.PI * 0.15),
      ease: "power1.out",
      duration: 3
    })
  }

  render(){
    if(this.particles){
      this.particles.render(this.camera)      

      if(this.cameraNeedUpdate){
        this.cameraNeedUpdate = false
        this.animCamera()
      }
    }
  }

  resize(sizes){    
    this.camera.aspect = sizes.width / sizes.height
    this.camera.updateProjectionMatrix()

    if(this.particles){
      this.particles.setParticlesSize()
    }
  }
}